import http from './http';

export default {
//   loginM:params => http.post('/front/pc/customer/pwdLogin', params),
//   uRegister:params => http.post('/front/pc/customer/register', params),
  yanZ:params => http.get('/send?phone='+params.input1+'&type=0'),
};



// WEBPACK FOOTER //
// ./src/utils/request.js